import axios from 'axios';
import axiosRetry from 'axios-retry';

// Create an axios instance with a base URL
const api = axios.create({
  baseURL: 'https://new.xymatauri.com', // Use domain URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Configure axios-retry
axiosRetry(api, {
  retries: 2,  // Reduced from 3 to 2
  retryCondition: (error) => {
    return error.response && error.response.status === 429;
  },
  retryDelay: (retryCount) => {
    console.warn(`Retrying request... Attempt #${retryCount}`);
    return axiosRetry.exponentialDelay(retryCount);
  },
});

// Response interceptor for logging and additional handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 429) {
      console.error('Rate limit exceeded. Retrying...');
    } else {
      console.error('Request failed:', error);
    }
    return Promise.reject(error);
  }
);

// Example API functions
export const getUserProfile = (userId) => api.get(`/users/${userId}`);
export const updateUserProfile = (userId, data) => api.put(`/users/${userId}`, data);
export const createStripeCustomer = (userId) => api.post(`/users/${userId}/create-stripe-customer`);

export const fetchProducts = async () => {
  try {
    const response = await api.get('/products');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch products:', error);
    throw error;
  }
};

export default api;
